import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M13.4,2.6C13,2.2,12.5,2,12,2h-0.7c0-0.7-0.6-1.3-1.3-1.3H6C5.3,0.7,4.7,1.3,4.7,2H4C3.5,2,3,2.2,2.6,2.6 C2.2,3,2,3.5,2,4v9.3c0,0.5,0.2,1,0.6,1.4C3,15.1,3.5,15.3,4,15.3h8c0.5,0,1-0.2,1.4-0.6c0.4-0.4,0.6-0.9,0.6-1.4V4 C14,3.5,13.8,3,13.4,2.6z M6,2l4,0v1.3l-4,0L6,2z M6,2C6,2,6,2,6,2L6,2z M12.7,13.3c0,0.2-0.1,0.3-0.2,0.5S12.2,14,12,14H4 c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5V4c0-0.2,0.1-0.3,0.2-0.5C3.7,3.4,3.8,3.3,4,3.3h0.7c0,0.7,0.6,1.3,1.3,1.3h4 c0.7,0,1.3-0.6,1.3-1.3H12c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5V13.3z"
    />
  </svg>
);

const PasteIcon = (props) => <Icon component={svg} {...props} />;

export default PasteIcon;
